import React, { useCallback, useContext } from "react";
import { useTranslation } from 'react-i18next';
import LazyLoad from "react-lazyload";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import './LanguageSelector.css';
import { Circles } from "react-loader-spinner";
import { UserSettingsContext } from "contexts/UserSettingsContext";
import GenericDropdown from "components/dropdowns/GenericDropdown";

const languages = [
    { code: 'en', name: 'English'},
    { code: 'de', name: 'German'}
];

export const LanguageSelector = () => {
    const { t, i18n } = useTranslation();
    const { updateSetting } = useContext(UserSettingsContext);
    const placeholder = <Circles width="25" height="25" ariaLabel="loading animation" wrapperClass="mt-1" />;

    const handleChangeLanguage = useCallback((code) => {
        updateSetting('language', code.code);
        i18n.changeLanguage(code.code).catch(err => console.error('Error changing language to', code.code, ':', err));
    }, [i18n, updateSetting]);

    return (
        <Card>
            <CardHeader className="d-flex align-items-center justify-content-between">
                    <h5 className="title">{t('settings.language.title')}</h5>
            </CardHeader>
            <CardBody style={{minHeight: "0px"}}>
                <Row className="justify-content-center align-items-center">
                    {languages.map(lang => (
                        <Col
                            md="4"
                            key={lang.code}
                            onClick={() => handleChangeLanguage(lang)}
                        >
                            <Card className="text-center language-card" style={{'backgroundColor': i18n.language === lang.code ? '#ba54f5' : '#fff'}}>
                                <CardBody>
                                    <LazyLoad height={30} placeholder={placeholder}>
                                        <img alt={lang.name} src={require(`./../../assets/img/${lang.code}.jpg`)} />
                                    </LazyLoad>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    )
};

export const LanguageDropdown = () => {
    const { t, i18n } = useTranslation();
    const { updateSetting } = useContext(UserSettingsContext);

    const handleChangeLanguage = useCallback((code) => {
        updateSetting('language', code.code);
        i18n.changeLanguage(code.code).catch(err => console.error('Error changing language to', code.code, ':', err));
    }, [i18n, updateSetting]);

    return (
        <GenericDropdown items={languages.map(lang => ({ label: lang.name, ...lang }))} onItemSelect={handleChangeLanguage}>
            <div className="photo">
                {/*<LazyLoad height={30} placeholder={placeholder}>*/}
                    <img alt={t('menu.languagePictureAlt')} src={require(`./../../assets/img/${i18n.language}.jpg`)} />
                {/*</LazyLoad>*/}
            </div>
        </GenericDropdown>
    );
};